/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

//components
import NavigationMenu from './NavigationMenu';  

//style
import "./Header.scss";

// jQuery
import $ from "jquery";

// react-icons
import { FaUser } from 'react-icons/fa';

const Header = () => {
  const authUser = useSelector((store) => store.auth.authUser);
  const loginSettings = useSelector((store) => store.auth.loginSettings);

  const menuItems = React.useMemo(() => [
    {
      id: 1,
      title: "Hizmetlerimiz",
      url: "#",
      subMenu: [
        {
          id: 200,
          title: "Bayi Sadakat Programı",
          url: "/#bayi-sadakat",
        },
        {
          id: 201,
          title: "Çalışan Sadakat Programı",
          url: "/#calisan-sadakat",
        },
        {
          id: 202,
          title: "Sadakat Modülleri",
          url: "/#sadakat-modulleri",
        },
        {
          id: 203,
          title: "Teknoloji Altyapısı",
          url: "/#teknoloji-altyapisi",
        },
      ],
    },
    { id: 2, title: "İletişim", url: "https://jarvis.com.tr/iletisim", newWindow: true },
  ], []);

  const handleClickHamburger = React.useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const toggleOffcanvas = React.useCallback(() => {
    $(".offcanvas-collapse").toggleClass("open");
    $(".offcanvas-overlay").toggleClass("open");
    $(".page-content").toggleClass("blur");
    $(".user-avatar").toggleClass("blur");
  }, []);

  React.useEffect(() => {
    const $offcanvasToggle = $('[data-toggle="offcanvas"]');
    const $offcanvasOverlay = $(".offcanvas-overlay");

    $offcanvasToggle.on("click", toggleOffcanvas);
    $offcanvasOverlay.on("click", toggleOffcanvas);

    return () => {
      $offcanvasToggle.off("click", toggleOffcanvas);
      $offcanvasOverlay.off("click", toggleOffcanvas);
    };
  }, [toggleOffcanvas]);

  return (
    <div className="sticky-top bg-white shadow-lg">
      <header>
        <nav className="navbar navbar-expand-xl">
          <div className="container-xxl">
            <a href="/" className="navbar-logo">
              {loginSettings?.logo && (
                <img src={loginSettings?.logo} alt="logo-header" />
              )}

              {/* <div className="role">
                {authUser?.roleName && authUser?.roleName}
              </div> */}
            </a>

            <div className="order-xl-2 order-1 col-xl-2 ms-auto">
              <div className="d-flex justify-content-end align-items-center">
                <Link
                  to="/login"
                  className="btn btn-slate d-flex align-items-center gap-2 px-4 py-2 text-white"
                  style={{
                    borderRadius: '8px',
                  }}
                >
                  <FaUser size={16} style={{ color: '#ffffff' }} />
                  <span>Giriş Yap</span>
                </Link>
              </div>
            </div>

            <button
              className="navbar-toggler collapsed order-xl-3 order-2"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target=".navbar-collapse"
              onClick={() => handleClickHamburger()}
            >
              <span />
              <span />
              <span />
            </button>

            <div className="collapse navbar-collapse order-xl-1 order-3 col-xl-auto">
              <NavigationMenu menuItems={menuItems} />
            </div>
          </div>
        </nav>
      </header>
    </div>
  );
};

export default Header;
